<template>
  <div class="print-share-links">
    <div class="options">
      <CdrLink
        tag="button"
        modifier="standalone"
        class="options__button options__button--print"
        @click="printList('wishlist')"
      >
        Print
        <IconPrint />
      </CdrLink>
      <CdrLink tag="button" modifier="standalone" class="options__button options__button--share" @click="open">
        Share
        <IconUpload />
      </CdrLink>
    </div>
    <CdrModal label="Share Wishlist" :opened="showShare" @closed="close">
      <template #title>
        <h3 class="share__modal-title">Share Wishlist "{{ listName }}"</h3>
      </template>
      <hr />
      <div class="share__body">
        <div v-if="isListPublic">
          <div class="share__form">
            <div class="share__input-wrapper">
              <CdrInput
                id="listUrl"
                v-model="listUrl"
                label="Share Wishlist Link"
                :hide-label="true"
                class="share__input"
                :class="{ copied: copied }"
                :placeholder="listUrl"
                readonly
              />
            </div>
            <div class="share__button-wrapper">
              <CdrButton modifier="secondary" class="share__button" @click="copyUrl">
                Copy
                <IconCheckLg v-if="copied" class="copy__icon" />
              </CdrButton>
            </div>
          </div>
          <CdrButton modifier="secondary" class="email__button" @click="sendMail"> Email </CdrButton>
        </div>
        <div v-else class="share__alert">
          <CdrBanner type="warning">
            <template #icon-left>
              <IconWarningFill />
            </template>
            Your wish list is currently Private and only you can see your wish list. Please change your wish list to
            Public to share it with others.
          </CdrBanner>
        </div>
      </div>
    </CdrModal>
  </div>
</template>

<script>
import {
  CdrButton,
  CdrInput,
  CdrLink,
  CdrBanner,
  IconPrint,
  IconUpload,
  IconWarningFill,
  IconCheckLg,
  CdrModal,
} from '@rei/cedar';
import metrics from '../../utils/metrics';

export default {
  name: 'PrintShareButtonsComponent',
  components: {
    CdrButton,
    CdrInput,
    CdrLink,
    CdrBanner,
    IconPrint,
    IconUpload,
    IconWarningFill,
    IconCheckLg,
    CdrModal,
  },
  props: {
    listName: {
      type: String,
      required: true,
    },
    isListPublic: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showShare: false,
      listUrl: null,
      mailto: "mailto:?subject=Here's%20my%20REI%20wish%20list&body=Take a look at the REI wish list I created:",
      copied: false,
    };
  },
  mounted() {
    this.listUrl = window.location.href;
  },
  methods: {
    printList() {
      metrics.metricsClick('Print');
      window.print();
    },
    copyUrl() {
      metrics.metricsClick('Share copy');
      const copyText = document.getElementById('listUrl');
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(copyText.value);
      this.copied = true;
    },
    open() {
      metrics.metricsClick('Share');
      this.showShare = true;
    },
    close() {
      this.showShare = false;
      this.copied = false;
    },
    sendMail() {
      metrics.metricsClick('Share email');
      window.location.href = `${this.mailto} ${this.listName} ${this.listUrl}`;
    },
  },
};
</script>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens';
body .site-header {
  z-index: 1;
}

.print-share-links {
  display: flex;
  justify-content: flex-end;
}
.options {
  &__button {
    color: $cdr-color-text-brand;

    &--print {
      display: none;
    }

    svg {
      fill: $cdr-color-text-brand;
      margin-left: $cdr-space-half-x;
    }
  }
}
svg.copy__icon {
  fill: $cdr-color-text-success;
}
.share {
  &__form {
    display: flex;
    justify-content: space-between;
  }
  &__input-wrapper {
    width: 100%;
  }
  &__button {
    margin-left: $cdr-space-one-x;
  }
  &__body {
    text-align: left;
    padding-top: $cdr-space-one-and-a-half-x;
  }
  &__modal-title {
    @include cdr-text-heading-sans-400;
    margin-bottom: 0;
  }
  &__overlay {
    background-color: rgba(0, 0, 0, 0.5);
    height: 100%;
    left: 0;
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 0;
  }
}

.email__button {
  display: block;
  margin-top: $cdr-text-heading-serif-700-size;
}

@media screen and (min-width: $cdr-breakpoint-md) {
  .options {
    &__button--print {
      display: inline-flex;
      margin-right: $cdr-space-one-x;
    }
  }
}
</style>
